import './style.sass';

import parse from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const MainTitle = ({
    MainTitle: { titleAnimation, titleMainText, center, subtitleContainer, subText, subTextNormal },
    children = '',
    withLink,
    awards,
    className,
    classNameImg,
    classNameTitle,
    classNameText,
}) => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={0} animateOnce={true} duration={1}>
            <FullWrapper isMargin={false} caseName="main-title">
                <div className="main-title__main-wrap">
                    <div
                        className={`main-title__main-container ${
                            center && 'main-title__main-container--center'
                        }`}
                    >
                        <ScrollAnimation
                            animateIn="fadeIn"
                            delay={500}
                            offset={0}
                            animateOnce={true}
                            duration={1}
                            className="main-title__text-container"
                        >
                            <h1
                                className={`${
                                    classNameTitle ? classNameTitle : ''
                                } main-title__title `}
                            >
                                {parse(titleMainText)}
                            </h1>
                            {withLink && (
                                <a
                                    className="button main-title__button"
                                    href={withLink.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span>{parse(withLink.textLink)}</span>
                                </a>
                            )}
                            {awards && (
                                <div className="awards">
                                    {awards.map(({ link, img }, index) => (
                                        <a
                                            key={index}
                                            className="awards__link"
                                            href={link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                className="awards__img"
                                                src={img}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </a>
                                    ))}
                                </div>
                            )}
                            {subText?.text && !subTextNormal && (
                                <div
                                    style={{ color: subText.color }}
                                    className={`main-title__text ${
                                        classNameText ? classNameText : ''
                                    }`}
                                >
                                    {parse(subText.text)}
                                </div>
                            )}
                            {subText?.text && subTextNormal && (
                                <div
                                    style={{ color: subText.color }}
                                    className={`main-title__text--normal ${
                                        classNameText ? classNameText : ''
                                    }`}
                                >
                                    {parse(subText.text)}
                                </div>
                            )}
                            <div className={`main-title__subtitle-container ${className}`}>
                                {subtitleContainer.map(
                                    ({ modeText, colorMode, nameText, subnameText }, index) => (
                                        <div key={index} className="main-title__subtitle-item">
                                            <div
                                                className="main-title__subtitle-mode"
                                                style={{ color: colorMode }}
                                            >
                                                {modeText ? parse(modeText) : modeText}
                                            </div>
                                            <div className="main-title__subtitle-name">
                                                {nameText ? parse(nameText) : null}
                                            </div>
                                            <div className="main-title__subtitle-subname">
                                                {subnameText ? parse(subnameText) : subnameText}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </ScrollAnimation>
                        <ScrollAnimation
                            className={`main-title__main-img ${classNameImg}`}
                            animateIn="zoomIn"
                            offset={0}
                            animateOnce={true}
                            duration={1.2}
                        >
                            <img src={titleAnimation} alt="" loading="lazy" />
                        </ScrollAnimation>
                    </div>
                </div>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div
                        className="main-title__info-container"
                        style={children ? { display: 'block' } : { display: 'none' }}
                    >
                        {children}
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default MainTitle;
